import { formFieldsValidation } from '../wcl-helpers.js';
import { SendRequest } from '../wcl-helpers.js';



if (document.querySelector('.wcl-set-new-password-form')) {
    const form = document.querySelector('.wcl-set-new-password-form');

    // Get variables
    const formInputs = form.querySelectorAll('.data-input');
    const wpnonce = form.querySelector('#wcl_set_new_password_wpnonce');
    const submitBtn = form.querySelector('.wcl-button');

    // Get UI element
    const message = form.querySelector('.wcl-message');

    submitBtn.addEventListener('click', e => {
        e.preventDefault();

        message.classList.remove('show', 'error', 'success');

        // Validation
        if (formFieldsValidation(formInputs)) {
            return;
        }

        form.classList.add('loading');

        const userKey = form.querySelector('#user_key');
        const userLogin = form.querySelector('#user_login');
        const userPassword = form.querySelector('#user-new-password');

        // Prepare data to request
        const requestArgs = `&wpnonce=${wpnonce.value}&user_key=${userKey.value}&user_login=${userLogin.value}&user_password=${encodeURIComponent(userPassword.value)}`;


        SendRequest('set_new_password', requestArgs).then(function (res) {
            form.classList.remove('loading');

            let response = JSON.parse(res);

            if (response.success == '1') {
                message.innerHTML = response.message;
                message.classList.add('show', 'success');
            } else {
                throw new Error(response.message);
            }

        }).catch(function (err) {
            // Error
            form.classList.remove('loading');

            message.innerHTML = err;
            message.classList.add('show', 'error');
        });
    });
}